import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SeoHead from '../../components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Desguace en Terrassa – Compra de Coches',
  description: 'Compramos coches en Terrassa al mejor precio. Siniestrados, averiados, sin ITV. Recogida gratuita y pago inmediato.',
  provider: {
    '@type': 'AutoDealer',
    name: 'Desguace Barcelona',
    telephone: '+34932932913',
    address: { '@type': 'PostalAddress', addressLocality: 'Terrassa', addressRegion: 'Cataluña', addressCountry: 'ES' },
  },
  areaServed: { '@type': 'City', name: 'Terrassa' },
  url: `${siteUrl}/desguace-terrassa`,
};

export default function DesguaceTerrassaPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Desguace en Terrassa | Vende tu Coche al Mejor Precio | Recogida Gratis"
        description="Desguace en Terrassa. Compramos coches siniestrados, averiados o sin ITV al mejor precio. Recogida gratuita en toda Terrassa y Vallès Occidental. Pago inmediato."
        keywords="desguace Terrassa, vender coche Terrassa, compra coches Terrassa, coche siniestrado Terrassa, desguace Vallès"
        canonical={`${siteUrl}/desguace-terrassa`}
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#1a2332] to-[#2d3e50]">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
              Desguace en Terrassa
            </h1>
            <p className="text-xl text-white/90 leading-relaxed">
              Compramos tu coche en Terrassa y alrededores. Recogida gratuita a domicilio y pago al momento.
            </p>
          </div>
        </section>

        {/* Contenido Principal */}
        <article className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            
            <div className="prose prose-lg max-w-none mb-12">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                <strong>Desguace Terrassa</strong> ofrece el mejor servicio de compra de vehículos en una de las ciudades más importantes del Vallès Occidental. Si tienes un coche que quieres vender en Terrassa, somos tu mejor opción.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Con más de <strong>15 años de experiencia</strong> en el sector, hemos comprado miles de vehículos en Terrassa y alrededores. Ofrecemos recogida gratuita, pago inmediato y gestión completa de todos los trámites legales.
              </p>
            </div>

            {/* Zonas de Terrassa */}
            <section className="mb-16">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                Zonas de Terrassa Donde Operamos
              </h2>
              
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
                {['Centre', 'Ca n\'Anglada', 'Sant Pere', 'Egara', 'Les Fonts', 'Can Palet', 'Vallparadís', 'La Maurina', 'Roc Blanc', 'Can Jofresa', 'Torre-sana', 'Les Arenes'].map((zona) => (
                  <div key={zona} className="bg-[#f8f9fa] p-4 rounded-lg text-center">
                    <i className="ri-map-pin-line text-[#ff6b35] text-xl mb-2"></i>
                    <p className="text-sm font-medium text-[#1a2332]">{zona}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Ventajas */}
            <section className="mb-16">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                Ventajas de Nuestro Servicio en Terrassa
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-truck-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Grúa Gratuita</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Recogemos tu coche en cualquier punto de Terrassa sin coste adicional.
                  </p>
                </div>

                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-time-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Servicio Express</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Tasación en 24 horas y recogida en el menor tiempo posible.
                  </p>
                </div>

                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-money-euro-circle-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Pago Inmediato</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Recibes el dinero en el momento de la recogida del vehículo.
                  </p>
                </div>

                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-file-list-3-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Trámites Incluidos</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Gestionamos baja en DGT, certificado de destrucción y toda la documentación.
                  </p>
                </div>
              </div>
            </section>

            {/* Tipos de coches */}
            <section className="mb-16 bg-[#f8f9fa] p-8 rounded-2xl">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                Compramos Todo Tipo de Coches en Terrassa
              </h2>
              
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Coches siniestrados:</strong> Accidentes, siniestro total, daños graves.</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Coches averiados:</strong> Motor, caja de cambios, sistema eléctrico.</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Coches sin ITV:</strong> ITV caducada o vehículos que no la pasan.</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Coches antiguos:</strong> Vehículos viejos, con muchos km o en desuso.</p>
                </div>
              </div>
            </section>

            {/* CTA Final */}
            <section className="bg-gradient-to-br from-[#1a2332] to-[#2d3e50] rounded-2xl p-12 text-center text-white">
              <h2 className="text-4xl font-black mb-4">
                Vende tu Coche en Terrassa Hoy
              </h2>
              <p className="text-xl mb-8 text-white/90">
                Tasación gratuita y sin compromiso
              </p>
              <a 
                href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20valorar%20mi%20coche%20en%20Terrassa" 
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center px-10 py-5 bg-[#25d366] text-white rounded-full font-bold text-lg hover:bg-[#1da851] transition-all shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-3 text-2xl"></i>
                WhatsApp 932 932 913
              </a>
            </section>

          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}
